import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import DataTable from "@components/DataTable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import { adminDeleteSpecificOrganization } from "@services/client-list.service";
import Notfound from "@components/Not-Found";
import moment from "moment";
import Loader from "@components/common/Loader";
// import DatePicker from 'react-date-picker';
import FilterForm from "@components/common/Compliance-AddFilter/FilterForm";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
} from "@services/list-management.service";
import {
  adminGetCheckpoint,
  GetCheckpointPEComplianceTask,
  UpdateBulkStatusCheckpointPEComplianceTask,
} from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {
  clientGetFunction,
  clientGetLocation,
} from "@services/location.service";
import { NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import SearchableDropdown from "@_common/SearchableDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { tableStatusStyle } from "@_common/colors";
import { countKeysWithValues } from "@_common/text-helpers";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import MenuActivitySvgComponent from "../../../../assets/svg-components/left-menu/menuactivity";
import ModuleFilter from "@components/common/ModuleFilter";

interface IComplianceTaskListProps {}

const ComplianceTaskList: React.FunctionComponent<IComplianceTaskListProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [firstDay, setFirstDay] = useState(new Date());
  const [lastDay, setLastDay] = useState(new Date());
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [complianceStatusList] = useState([
    { value: "PENDING", label: "Pending" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getDataCompliance();
      getDropdownInfo();
      getSmartFilterList();
      setDate(new Date());
      let dates = params.date ? new Date(params.date) : new Date();
      var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(firstDay);
      setLastDay(lastDay);

      getCategoryLawList("", "", "");
      getLegislationList("", "", "");
      getLegislationRuleList("", "", "");
      getLocationList("", "");
      // getLocationFunctions('', '', '')
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getDataCompliance();
      getDropdownInfo();
      getSmartFilterList();
      // getLocationList("");
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.firstDay && params.lastDay) {
        // setDate(new Date(params.date));
        var firstDay = new Date(params.firstDay);
        var lastDay = new Date(params.lastDay);
        setFirstDay(firstDay);
        setLastDay(lastDay);
      } else {
        setDate(new Date());
      }

      setRequest({
        country_id: getValue(params, `country_id`, "101"),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        frequency_id: getValue(params, `frequency_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        function_id: getValue(params, `function_id`, ""),
        checkpoint_id: getValue(params, `checkpoint_id`, ""),
      });
      if (getValue(params, `country_id`, "")) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "") ||
        getValue(params, `legislation_rule_id`, "") ||
        getValue(params, `location_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, "")
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `legislation_id`, "")
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, "")
        );
        getLocationList("", getValue(params, `location_id`, ""));
        getLocationFunctions(
          "",
          getValue(params, `location_id`, ""),
          getValue(params, `function_id`, "")
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
        getLocationList("", "");
        // getLocationFunctions('', '', '')
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };
  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getDataCompliance = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        setComplianceTypeList(
          list.filter((item: object) => getValue(item, `is_active`, false))
        );
      }
    } catch (error) {}
  };
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let dates = params.date ? new Date(params.date) : new Date();
    var firstDay = params.firstDay
      ? params.firstDay
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var lastDay = params.lastDay
      ? params.lastDay
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]"
    );
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      from_date: moment(firstDay).format("YYYY-MM-DD"),
      to_date: moment(lastDay).format("YYYY-MM-DD"),
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
      compliance_task_ids: compliance_task_ids,
      compliance_type_id:
        getValue(mainParams, `id`, "") === "id"
          ? ""
          : getValue(mainParams, `id`, ""),
      // frequency_id: getValue(params, `frequency_id`, "")
      // 	? getValue(params, `frequency_id`, "")
      // 	: getValue(request, `frequency_id`, ""),
      location_id: getValue(params, `location_id`, "")
        ? getValue(params, `location_id`, "")
        : getValue(request, `location_id`, ""),
      function_id: getValue(params, `function_id`, "")
        ? getValue(params, `function_id`, "")
        : getValue(request, `function_id`, ""),
      compliance_status: getValue(params, `compliance_status`, ""),
      request_from: getValue(params, `request_from`, ""),
      request_type: getValue(params, `request_type`, ""),
      request_value: getValue(params, `request_value`, ""),

      // checkpoint_id: getValue(params, `checkpoint_id`, "")
      // 	? getValue(params, `checkpoint_id`, "")
      // 	: getValue(request, `checkpoint_id`, ""),
      smart_filter_tags: selectedIDs,
      sort_legal_due_date: params.sort_legal_due_date,
      sort_follow_up_date: params.sort_follow_up_date,
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await GetCheckpointPEComplianceTask(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.compliance_tasks`, []).map((item: object) => ({
            ...item,
            checkpoint_id: getValue(
              item,
              `pe_compliance.checkpoint.checkpoint_id`,
              ""
            ),
            frequency: getValue(
              item,
              `pe_compliance.checkpoint.frequency.text`,
              ""
            ),
            rule: getValue(
              item,
              `pe_compliance.checkpoint.legislation_rule.rule_name`,
              ""
            ),
            compliance_status_formatted: formatText(
              getValue(item, `compliance_status`, "")
            ),
            compliance_activity: getValue(
              item,
              `pe_compliance.checkpoint.compliance_activity`,
              ""
            ),
            legal_due_date: getValue(item, `legal_due_date`, "")
              ? moment(getValue(item, `legal_due_date`, "")).format(
                  "DD MMM YYYY"
                )
              : "",
            follow_up_date: getValue(item, `follow_up_date`, "")
              ? moment(getValue(item, `follow_up_date`, "")).format(
                  "DD MMM YYYY"
                )
              : "",
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
            industry: getValue(item, `industry.text`, ""),
            business_type: getValue(item, `business_type.text`, ""),
            location: getValue(
              item,
              `pe_compliance.location.location_name`,
              ""
            ),
            form_name: getValue(item, `pe_compliance.checkpoint.form_no`, ""),
            function: getValue(
              item,
              `pe_compliance.function.function_name`,
              ""
            ),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    if (e.target.value) {
      setSearchInput(e.target.value);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: 1,
        search_text: e.target.value,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!e.target.value) {
        getData();
      }
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      setSearchInput(e.target.value);
      delete params.search_text;
      let queryRequest = QueryRequestHelper(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!e.target.value) {
        getData();
      }
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificOrganization(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (name === "sort_legal_due_date") {
        delete params.sort_follow_up_date;
      }
      if (name === "sort_follow_up_date") {
        delete params.sort_legal_due_date;
      }
      let payload = {
        ...params,
        page_no: 1,
        [name]: value,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
    // window.location.reload()
  };
  const handleClickSort = (name: string) => {
    handleChangeStatus(name, switchFilter(name));
  };
  const switchFilter = (name: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let value = getValue(params, `${name}`, "")
      ? getValue(params, `${name}`, "")
      : "newest";
    switch (value) {
      case "newest":
        return "oldest";
      case "oldest":
        return "newest";
      default:
        return "newest";
    }
  };
  const HeaderButton = ({ label, name }: any) => {
    return (
      <div className="d-flex">
        <span>{label}</span>&nbsp;&nbsp;&nbsp;
        <p className="cursor-pointer" onClick={() => handleClickSort(name)}>
          ^
        </p>
      </div>
    );
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]"
    );

    let payload = {
      ...params,
      page_no: page_no,
      compliance_task_ids: compliance_task_ids,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]"
    );
    let payload = {
      ...params,
      limit: limit,
      compliance_task_ids: compliance_task_ids,
      page_no: 1,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/configuration/vendors/add/${id}`);
  };
  const rowClick = (obj: object) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();

    var firstDay = params.firstDay
      ? params.firstDay
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var lastDay = params.lastDay
      ? params.lastDay
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]"
    );
    let payload = {
      compliance_task_ids: compliance_task_ids,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(
      `/activities/task/compliance/list/detail/${getValue(
        mainParams,
        `id`,
        ""
      )}/${getValue(obj, `original.id`, "")}/${getValue(
        obj,
        `original.pe_compliance.checkpoint.id`,
        ""
      )}/${moment(firstDay).format("YYYY-MM-DD")}/${moment(lastDay).format(
        "YYYY-MM-DD"
      )}/${getValue(obj, `original.pe_compliance.location.id`, "")}/${getValue(
        obj,
        `original.pe_compliance.function.id`,
        ""
      )}?${queryRequest}`
    );
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Compliance Task ID",
        accessor: "compliance_task_id",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            // <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
            <>{row.values.compliance_task_id}</>
            // </NavLink>
          );
        },
      },
      // {
      // 	Header: "Checkpoint ID",
      // 	accessor: "checkpoint_id",
      // 	width: 200,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			// <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
      // 			<>{row.values.checkpoint_id}</>
      // 			// </NavLink>
      // 		);
      // 	},
      // },
      // {
      // 	Header: "Frequency",
      // 	accessor: "frequency",
      // 	width: 300,
      // },

      // {
      // 	Header: "Rule",
      // 	accessor: "rule",
      // 	width: 200,
      // },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 200,
      },
      {
        Header: (
          <HeaderButton label="Legal Due Date" name="sort_legal_due_date" />
        ),
        accessor: "legal_due_date",
        width: 200,
      },
      {
        Header: (
          <HeaderButton label="Followup Date" name="sort_follow_up_date" />
        ),
        accessor: "follow_up_date",
        width: 200,
      },
      {
        Header: "Location",
        accessor: "location",
        width: 200,
      },
      {
        Header: "Function",
        accessor: "function",
        width: 200,
      },
      {
        Header: "Form Name",
        accessor: "form_name",
        width: 200,
      },
      {
        Header: "Compliance Status",
        accessor: "compliance_status_formatted",
        width: 200,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 200,
      },
      // 		 {
      //   	Header: "Action",
      //   	width: 170,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //   			<>
      //   				<Button
      //   					color="primary"
      //   					onClick={() => handleEdit(row.original.id)}
      //   				>
      //   					Edit
      //   				</Button>
      //   			</>
      //   		);
      //   	},
      //   },
    ],
    []
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await UpdateBulkStatusCheckpointPEComplianceTask({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const handleNavigate = (id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/task/compliance/list/${id}?${queryRequest}`);
  };

  const [checkpointList, setCheckpointList] = useState([]);

  const getAllCheckpoint = async () => {
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: 100,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    let resp = await adminGetCheckpoint(queryRequest);
    if (resp) {
      setCheckpointList(
        getValue(resp, `data.checkpoints`, []).map((item: object) => ({
          value: getValue(item, `checkpoint_id`, ""),
          label: getValue(item, `checkpoint_id`, ""),
          id: getValue(item, `id`, ""),
        }))
      );
    }
  };

  const getDropdownInfo = async () => {
    let payload: any = {
      page_no: 1,
      page_size: 100,
    };
    let queryRequest = QueryRequestHelper(payload);
    let frequency = await adminGetListManagementGroupCode("frequency");
    if (frequency) {
      let list =
        getValue(frequency, `data.listItems.length`, 0) > 0
          ? getValue(frequency, `data.listItems`, []).filter((item: object) =>
              getValue(item, `is_active`, "")
            )
          : [];
      setFrequencyList(
        list.map((item: object) => ({
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
          id: getValue(item, `id`, ""),
        }))
      );
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let first = moment(firstDay).format("YYYY-MM-DD");
    let last = moment(lastDay).format("YYYY-MM-DD");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        firstDay: first,
        lastDay: last,
      };
      if (payload.firstDay && payload.lastDay) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };

  const handleNavigateCalenderView = () => {
    if (mainParams.id !== "id") {
      navigate(`/activities/task/compliance/list/calenderView/${mainParams.id}`);
    } else {
      toast.error("Please Open List Under Task Compliance");
    }
  };

  let selectedCompliance = complianceTypeList.filter(
    (item: any) => item.id == mainParams.id
  );

  const handleChangeFilterStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    frequency_id: "",
    location_id: "",
    function_id: "",
    checkpoint_id: "",
  });
  useEffect(() => {
    getAllCheckpoint();
  }, [
    request.country_id,
    request.state_id,
    request.category_of_law_id,
    request.legislation_id,
    request.legislation_rule_id,
  ]);

  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      location_id: "",
      function_id: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Locations  ----------------------------- */
  const [locationLoading, setLocationLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const getLocationList = async (value: string, id: string) => {
    try {
      setResetInput(false);
      setLocationLoading(true);
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let locations = await clientGetLocation(queryRequest);
      if (locations) {
        setLocations(
          getValue(locations, `data.locations`, []).map((item: object) => ({
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
            id: getValue(item, `id`, ""),
          }))
        );
        setLocationLoading(false);
        setValue(request, `location_id`, "");
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
    if (!value) {
      setValue(request, `location_id`, "");
      getLocationFunctions("", "", "");
    }
  };

  /* ---------------------------  Functions  ----------------------------- */
  const [functionLoading, setFunctionLoading] = useState(false);
  const [functions, setFunctions] = useState([]);

  const getLocationFunctions = async (
    value: string,
    location_id: string,
    id: string
  ) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      search_text: value,
      location_id: location_id,
      id: id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setResetInput(false);
      setFunctionLoading(true);
      let resp = await clientGetFunction(queryRequest);
      if (resp) {
        setFunctions(
          getValue(resp, `data.functions`, []).map((item: object) => ({
            value: getValue(item, `function_name`, ""),
            label: getValue(item, `function_name`, ""),
            id: getValue(item, `id`, ""),
          }))
        );
        setFunctionLoading(false);
        setValue(request, `function_id`, "");
      } else {
        setFunctionLoading(false);
      }
    } catch (error) {
      setFunctionLoading(false);
    }
    if (!value) {
      setValue(request, `function_id`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `state_id`, "");
        setRequest({
          ...request,
          // state_id: '',
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? getValue(e, `id`, "") : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", getValue(e, `id`, ""), "");
        getLegislationList("", getValue(e, `id`, ""), "");
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      }
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
      getAllCheckpoint();
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "location_id") {
      setRequest({
        ...request,
        location_id: getValue(e, `id`, "") ? getValue(e, `id`, "") : "",
      });
      getLocationFunctions(
        "",
        getValue(e, `id`, "") ? getValue(e, `id`, "") : "",
        ""
      );
    }
    if (type === "function_id") {
      setRequest({
        ...request,
        function_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  /* ---------------------------  Submit Smart filter ----------------------------- */

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds)
    );
    if (
      getValue(request, `country_id`, "")
      // ||
      // getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = new Date();
      var firstDay = params.firstDay
        ? params.firstDay
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var lastDay = params.lastDay
        ? params.lastDay
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        ...params,
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        status: "active",
        sort_by: params.sort_by,
        firstDay: moment(firstDay).format("YYYY-MM-DD"),
        lastDay: moment(lastDay).format("YYYY-MM-DD"),
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        compliance_type_id:
          getValue(mainParams, `id`, "") === "id"
            ? ""
            : getValue(mainParams, `id`, ""),
        // frequency_id: getValue(request, `frequency_id`, ""),
        location_id: getValue(request, `location_id`, ""),
        function_id: getValue(request, `function_id`, ""),
        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
                getValue(item, `id`, "")
              )
            : [],
        // checkpoint_id: getValue(request, `checkpoint_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      // getData();
    } else {
      toast.error("All fields are mandatory");
    }
  };
  /* ---------------------------  Smart filter dropdown state at runtime ----------------------------- */

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );
  let frequency_id =
    getValue(frequencyList, `length`, 0) > 0 &&
    frequencyList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `frequency_id`, "")
    );
  let location_id =
    getValue(locations, `length`, 0) > 0 &&
    locations.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );
  let function_id =
    getValue(functions, `length`, 0) > 0 &&
    functions.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_id`, "")
    );
  let checkpoint_id =
    getValue(checkpointList, `length`, 0) > 0 &&
    checkpointList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `checkpoint_id`, "")
    );
  let compliance_status_ID =
    getValue(complianceStatusList, `length`, 0) > 0 &&
    complianceStatusList.filter(
      (item: object) =>
        getValue(item, `value`, "") == getValue(params, `compliance_status`, "")
    );
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_pe_compliance"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to={
                  getValue(params, `request_from`, "") === "dashboard"
                    ? `/dashboard/compliance?from_date=${getValue(
                        params,
                        `from_date`,
                        ""
                      )}&to_date=${getValue(params, `to_date`, "")}`
                    : `/activities/task/compliance`
                }
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper me-2">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Activities
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  {/* License */}
                  <UncontrolledDropdown>
                    <DropdownToggle caret className="p-0">
                      <div className="d-flex align-items-center">
                        <h6 className="dashboard-wrapper__dropdown ms-0">
                          {getValue(selectedCompliance, `length`, 0) > 0
                            ? getValue(selectedCompliance, `[${0}].text`, "")
                            : ""}
                        </h6>
                        <img
                          src="/images/arrow-drop.svg"
                          className="img-fluid add-filter-wrapper__upload-image"
                        />
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      {complianceTypeList.map((item) => {
                        return (
                          <DropdownItem
                            onClick={() => {
                              handleNavigate(getValue(item, `id`, ""));
                            }}
                          >
                            {getValue(item, `text`, "")}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={firstDay ? new Date(firstDay) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (date && lastDay && new Date(date) > new Date(lastDay)) {
                      toast.error("From Date cannot be greater than To Date");
                    } else {
                      handleDate([date, lastDay]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select From Date"
                  maxDate={lastDay ? new Date(lastDay) : undefined}
                />
              </div>
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={lastDay ? new Date(lastDay) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (firstDay && date && new Date(firstDay) > new Date(date)) {
                      toast.error("To Date cannot be less than From Date");
                    } else {
                      handleDate([firstDay, date]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select To Date"
                  minDate={firstDay ? new Date(firstDay) : undefined}
                />
              </div>
              <button
                className="dashboard-wrapper__apply-btn ml-2"
                onClick={handleSubmitDate}
              >
                Apply
              </button>
              <RightMenuHeaders
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                //Calendar
                calendarViewActivitiesLicense={true}
                handleNavigateCalenderView={handleNavigateCalenderView}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <div className="d-flex">
              <NavLink
                to={
                  getValue(params, `request_from`, "") === "dashboard"
                    ? `/dashboard/compliance?from_date=${getValue(
                        params,
                        `from_date`,
                        ""
                      )}&to_date=${getValue(params, `to_date`, "")}`
                    : `/activities/task/compliance`
                }
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                />
              </NavLink>
              <UncontrolledDropdown>
                <DropdownToggle caret>
                  <div className="d-flex align-items-center">
                    <h6 className="dashboard-wrapper__dropdown">
                      {getValue(selectedCompliance, `length`, 0) > 0
                        ? getValue(selectedCompliance, `[${0}].text`, "")
                        : ""}
                    </h6>
                    <img
                      src="/images/arrow-drop.svg"
                      className="img-fluid add-filter-wrapper__upload-image"
                    />
                  </div>
                </DropdownToggle>
                <DropdownMenu>
                  {complianceTypeList.map((item) => {
                    return (
                      <DropdownItem
                        onClick={() => {
                          handleNavigate(getValue(item, `id`, ""));
                        }}
                      >
                        {getValue(item, `text`, "")}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            <div className="d-flex align-items-center">
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={firstDay ? new Date(firstDay) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (date && lastDay && new Date(date) > new Date(lastDay)) {
                      toast.error("From Date cannot be greater than To Date");
                    } else {
                      handleDate([date, lastDay]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select From Date"
                  maxDate={lastDay ? new Date(lastDay) : undefined}
                />
              </div>
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={lastDay ? new Date(lastDay) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (firstDay && date && new Date(firstDay) > new Date(date)) {
                      toast.error("To Date cannot be less than From Date");
                    } else {
                      handleDate([firstDay, date]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select To Date"
                  minDate={firstDay ? new Date(firstDay) : undefined}
                />
              </div>
              <button
                className="dashboard-wrapper__apply-btn ml-2"
                onClick={handleSubmitDate}
              >
                Apply
              </button>
            </div>
          </div>
          
          <div className="main-page-layout-wrapper has-module-filter">
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/configuration/vendors/add"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  isFilterVisible={isFilterVisible}
                  add="false"
                  calender={true}
                  handleNavigateCalenderView={handleNavigateCalenderView}
                  searchPlaceholder={"Search Task ID"}
                  id={
                    getValue(mainParams, `id`, "") === "id"
                      ? ""
                      : getValue(mainParams, `id`, "")
                  }
                  filterComplianceStatus
                  compliance_status_ID={compliance_status_ID}
                  complianceStatusOptions={complianceStatusList}
                  handleChangeFilterStatus={handleChangeFilterStatus}
                  handleChangeStatus={handleChangeStatus}
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>

              <div>
                <ModuleFilter
                  // filterCompliance
                  // peComplianceList={peComplianceList}
                  // handleChangeStatus={handleChangeStatus}
                  // compliance_status_ID={compliance_status_ID}
                  // complianceStatusOptions={complianceStatusList}
                  // handleChangeSelectByValue={handleChangeSelectByValue}
                  // filterComplianceStatus
                  filterComplianceStatus
                  compliance_status_ID={compliance_status_ID}
                  complianceStatusOptions={complianceStatusList}
                  handleChangeFilterStatus={handleChangeFilterStatus}
                  handleChangeStatus={handleChangeStatus}
                />
              </div>
              {/* {isFilterVisible && ( */}
              <FilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                country_ID={country_ID}
                state_ID={state_ID}
                frequency_id={frequency_id}
                checkpoint_id={checkpoint_id}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                frequencyList={frequencyList}
                checkpointList={checkpointList}
                additionalFilter={true}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                //---->  location
                locations={locations}
                getLocationList={getLocationList}
                location_id={location_id}
                locationLoading={locationLoading}
                //---->  functions
                function_id={function_id}
                functions={functions}
                functionLoading={functionLoading}
                getLocationFunctions={getLocationFunctions}
                resetInput={resetInput}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Activities"}
                subModuleName={"PE Compliance"}
              />
              {/* )} */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <Notfound />
                    </>
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
            </div>
            <div className="footer-wrapper d-flex justify-content-between">
              {list.length > 0 && (
                <img
                  src="/images/building-illustration.svg"
                  className="img-fluid"
                />
              )}
              {totalCount > 10 ? (
                <PaginationPage
                  totalCount={totalCount}
                  limit={limit}
                  pageNumber={page_no}
                  handleChangePagination={handleChangePagination}
                  handleChangeLimit={handleChangeLimit}
                />
              ) : (
                <p className="show-rows-count mt-3 d-flex">
                  Total Count:&nbsp;&nbsp;{" "}
                  <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                </p>
              )}
            </div>
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
    </DashboardLayout>
  );
};

export default ComplianceTaskList;
